<template>
    <div class="record">
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索"
                left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div class="todoList-module">
            <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
                <div class="main-box">
                    <div class="list" v-if="todoGroupList.length != 0">
                        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getEmployeeList"
                            :offset="20" :immediate-check="false">
                            <div v-for="item in todoGroupList" :key="item.allotDate">
                                <div class="list-title flex flex-y-center">
                                    <span>{{item.allotDate}}</span>
                                </div>
                                <div class="list-inner" v-for="oItem in item.data" :key="oItem.id" @click="toDetail(oItem)">
                                    <div class="list-card flex-row">
                                        <div class="image-inner flex-col">
                                            <img class="image" referrerpolicy="no-referrer" :src="oItem.empAvatar" alt="" />
                                        </div>
                                        <div class="text-inner  flex-col justify-between">
                                            <span class="list-name">{{oItem.empName}}</span>
                                            <div class="list-box flex-row">
                                                <span class="list-customer">{{oItem.contactCount}}位顾客</span>
                                                <span class="list-grounp">{{oItem.groupCount}}个客户群</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="section_6 flex-col"></div>
                                </div>

                            </div>
                        </van-list>
                    </div>
                    <div v-else class="flex flex-col flex-y-center">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png"
                            alt="" class="empty-icon" />
                        <div class="empty-txt">暂无分配记录～</div>
                    </div>
                </div>
            </van-pull-refresh>

        </div>
    </div>
</template>

<script>
import request from "@/utils/request";

export default {
    name: 'inheritRecord',
    components: {},
    data() {
        return {
            searchStr: "",
            loading: false,
            finished: false,
            refreshing: false,
            page: 1,
            total: 0,
            todoGroupList: [],
            // employeeList: []
        }
    },
    mounted() {
        this.getEmployeeList()
    },
    methods: {

        // 获取待办列表数据
        getEmployeeList() {
            const limit = 10
            this.loading = true
            request({
                url: `/transferCust/onAllotPage`,
                method: "get",
                params: { limit, page: this.page, empName: this.searchStr }   //, searchStr: this.searchStr
            })
                .then((res) => {
                    // 列表数据按日期分组
                    const { list = [] } = res.data || {}
                    for (const item of list) {
                        const groupLength = this.todoGroupList.length
                        if (groupLength && this.todoGroupList[groupLength - 1].allotDate === item.allotDate) {
                            this.todoGroupList[groupLength - 1].data.push(item.employeeList)
                        } else {
                            this.todoGroupList.push({
                                allotDate: item.allotDate,
                                data: item.employeeList
                            })
                        }
                    }
                    if (res.data.total < limit) {
                        this.finished = true
                    }
                    this.page += 1
                }).catch(() => {
                    this.finished = true
                }).finally(() => {
                    this.loading = false
                    this.refreshing = false
                })
        },

        onRefresh() {
            this.page = 1
            this.finished = false;
            this.todoGroupList = []
            this.getEmployeeList()
        },

        //分配详情
        toDetail(val) {
            this.$router.push({ name: "allocationDetails", query: { checkedEmployeesId: JSON.stringify(val.id) } });

        },
        selClear() {
            this.searchStr = "";
        },
        //搜索
        onSearch() {
            this.page = 1;
            this.todoGroupList = [];
            this.getEmployeeList();
        }


    },
}
</script>

<style scoped lang="less">
.record {
    height: 100vh;
}
.todoList-module {
    height: 100%;
    box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02) inset;
    background-color: #f9fafc;
    overflow-y: auto;
}
.main-box {
    min-height: calc(100vh - 102px);
    padding-bottom: 130px;
}
.list {
    background-color: #fff;
}

.list-title {
    height: 73px;
    color: rgba(160, 172, 181, 1);
    font-size: 26px;
    white-space: nowrap;
    line-height: 37px;
    text-align: left;
    // margin: 13px 0 0 0;
    background-color: rgba(245, 246, 247, 1);
    width: 750px;
    padding: 13px 30px;
}
.list-inner {
    width: 690px;
    // margin-bottom: 30px;
    background: #ffffff;
    border-radius: 20px;
}
.list-card {
    /* margin-top: 1px; */
    height: 130px;
    /* margin: 30px 0 0 30px; */
    background-color: rgb(255 255 255);
}

.image {
    z-index: 38;
    position: absolute;
    left: 0;
    top: 0;
    width: 70px;
    height: 70px;
}
.image-inner {
    z-index: 37;
    position: relative;
    width: 70px;
    height: 70px;
    border-radius: 10px;
    overflow: hidden;
    margin-left: 30px;
    margin-top: 30px;
}

.text-inner {
    width: 90px;
    height: 92px;
    margin-left: 30px;
    margin-top: 30px;
}
.list-name {
    width: 90px;
    height: 42px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 30px;
    white-space: nowrap;
    line-height: 42px;
    text-align: left;
}
.list-customer {
    width: 89px;
    height: 37px;
    display: inline-block;
    color: rgba(160, 172, 181, 1);
    font-size: 26px;
    white-space: nowrap;
    line-height: 37px;
    text-align: left;
    margin-top: 13px;
}

.list-grounp {
    width: 89px;
    height: 37px;
    display: inline-block;
    color: rgba(160, 172, 181, 1);
    font-size: 26px;
    white-space: nowrap;
    line-height: 37px;
    text-align: left;
    margin: 13px 0 0 20px;
}
.section_6 {
    width: 590px;
    height: 1px;
    background-color: rgba(215, 215, 215, 1);
    // margin: 2px 0 0 170px;
    // margin-left: 130px;
    margin: 0 0 6px 130px;
}
.empty-icon {
    width: 280px;
    height: 280px;
    margin-top: 179px;
}
.empty-txt {
    font-size: 30px;
    color: #a0acb5;
}

.list-box {
    margin-top: -12px;
}
:deep(.van-search .van-cell) {
    background-color: #ffffff !important;
}

:deep(.search-button.van-search) {
    background-color: #f5f6f7 !important;
    padding: 30px 30px 30px 0px;
}
:deep(.search-button .van-icon) {
    font-size: 28px;
}
:deep(.search-button .van-search__content) {
    padding-left: 20px !important;
}
:deep(.search-button .van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 3px 20px 0 20px !important;
    margin-right: 0 !important;
}

:deep(.van-icon__image) {
    height: 28px;
    display: inline-block;
}
:deep(.van-field__control) {
    font-size: 28px !important;
}
</style>
